import React, { useEffect, useState } from 'react';

function Header() {
  return (
    <header className="text-center py-4 bg-light">
      <h1 className="display-5 fw-bold">Расчет кровли</h1>
    </header>
  );
}

export default Header;
